import AppFooter from 'components/AppFooter'
import AppTable from 'components/AppTable'

export default function registerComponents (Vue) {
  Vue.component('app-footer', AppFooter)
  Vue.component('app-table', AppTable)
}



/** WEBPACK FOOTER **
 ** ./src-docs/app/config/registerComponents.js
 **/